import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useHackathon from '@/data/hook/hackathon/useHackathon';
import useAuth from '@/data/hook/useAuth';
import { classNamePodium } from '@/utils/hackathon';
import ProjectPermissions from '@/utils/permissions/ProjectPermission';
import { twMerge } from 'tailwind-merge';
import Card from '../Card';
import ProjectCardProps from './ProjectCardProps';

export default function CreatePodiumCard({
  project,
  onMutate,
  rank,
  className,
}: ProjectCardProps & { rank?: number }) {
  const { user } = useAuth();
  const { hackathon, isLoading } = useHackathon();

  const permissions = new ProjectPermissions({
    user,
    model: project,
    hackathon,
    isLoadingHackathon: isLoading,
  });

  return (
    <Card
      key={project.id}
      project={project}
      className={twMerge(
        'shadow-2xl',
        classNamePodium[rank || 4],
        className?.base,
      )}
    >
      <ConditionalRenderer condition={permissions.canInteract()}>
        <Card.Interactions project={project} onMutate={onMutate} />
      </ConditionalRenderer>
      <Card.Banner url={project.image} />
      <Card.FlexGroup>
        <Card.Title title={project.title} className="grow" />
        <Card.Ranking position={rank || 0} />
      </Card.FlexGroup>
      <Card.Tags tool={project.tool} flags={project.flags} />
      <div className="flex flex-col gap-1">
        <Card.CompleteOwners
          users={project.users}
          equipName={project.equipName}
          teacherMentor={project.teacherMentor}
        />
        <Card.Unit units={project?.units} />
      </div>
    </Card>
  );
}
